module.exports = __webpack_public_path__ + "static/media/groups.0e9116e7.svg";